import { render, staticRenderFns } from "./add-param.vue?vue&type=template&id=7e31aa44"
import script from "./add-param.vue?vue&type=script&lang=js"
export * from "./add-param.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e31aa44')) {
      api.createRecord('7e31aa44', component.options)
    } else {
      api.reload('7e31aa44', component.options)
    }
    module.hot.accept("./add-param.vue?vue&type=template&id=7e31aa44", function () {
      api.rerender('7e31aa44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/physicalmodel/add-param.vue"
export default component.exports